import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-wwwwww',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="text-center p-0 border-0">
      <div class="p-0 mt-0">
        <div class="container px-0">
          <!-- Mapa Satelital GPS -->
          <iframe
            title="Google Maps Location - ESFAPA"
            width="100%"
            height="500"
            src="https://maps.google.com/maps?width=100%25&amp;height=500&amp;hl=es&amp;q=+(Escuela%20de%20Bellas%20Artes%20Felipe%20Guam%C3%A1n%20Poma%20de%20Ayala-Ayacucho)&amp;t=k&amp;z=18&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            style="border: 0;"
          ></iframe>
          <!-- Vista de Calle / Embedded Street View Map -->
          <iframe
            title="Google Street View - ESFAPA"
            src="https://www.google.com/maps/embed?pb=!4v1750534065961!6m8!1m7!1syWFe4Rj4ga1j6fqlrkocMA!2m2!1d-13.15626194436401!2d-74.21787224051161!3f200.16657941141062!4f3.2355809602561294!5f0.7820865974627469"
            width="100%"
            height="620"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            style="border: 0;"
          ></iframe>
        </div>
      </div>

      <div class="card-body">
        <div class="row d-flex justify-content-center align-items-center">
          <!-- Sección Información Institucional -->
          <div class="text-center p-1 col-md-6 col-lg-4 col-xl-4">
            <h5 class="footer-links my-0 ffont">
              Escuela Superior de Formación Artística
            </h5>
            <p class="my-0">"Felipe Guamán Poma de Ayala"</p>

            <div class="container col-md-5 px-1 my-2">
              @if (imageSrc()) {
                <img
                  class="img-fluid"
                  style="width: 190px; height: 190px; position: relative; object-fit: unset;"
                  [src]="imageSrc()"
                  alt="Logo Diario ESFAPA"
                />
              }
            </div>
            <div>
              <p class="text-primary mb-0">
                Copyright ESFAPA Ayacucho {{ currentYear }}
              </p>
            </div>
          </div>

          <!-- Sección Dirección y Créditos -->
          <div class="container text-center p-1 col-md-6 col-lg-4 col-xl-4">
            <div>
              <p class="text-center mb-2">
                Jr. Mariano Melgar Nº 398, Distrito Jesús Nazareno Huamanga, Ayacucho
              </p>
            </div>
            <div>
              <p class="small text-muted mb-0">
                Plataforma desarrollada por: ricardomallqui6&#64;gmail.com
              </p>
            </div>
          </div>

          <!-- Sección Redes Sociales y Contacto -->
          <div class="container text-center p-1 col-md-6 col-lg-4 col-xl-4">
            <div>
              <h5 class="ffont">{{ pageName }}</h5>
            </div>
            <p class="mb-2">Teléfono: 066-287499</p>

            <div class="text-center justify-content-center">
              <button
                type="button"
                class="btn p-1"
                aria-label="WhatsApp"
                (click)="openInNewTab('https://api.whatsapp.com/send?phone=+51966999215&text=Hola%20bienvenido')"
              >
                <i class="bi bi-whatsapp" style="color: #069d12ff; font-size: 34px;"></i>
              </button>

              <button
                type="button"
                class="btn p-1"
                aria-label="Facebook"
                (click)="openInNewTab('https://web.facebook.com/bellasartes.ayacucho')"
              >
                <i class="bi bi-facebook" style="color: #0672a0ff; font-size: 34px;"></i>
              </button>

              <button
                type="button"
                class="btn p-1"
                aria-label="Facebook Messenger"
                (click)="openInNewTab('https://m.me/bellasartes.ayacucho')"
              >
                <i class="bi bi-messenger" style="color: #00B2FF; font-size: 34px;"></i>
              </button>

              <button
                type="button"
                class="btn p-1"
                aria-label="Instagram"
                (click)="openInNewTab('https://instagram.com/bellasartes.ayacucho')"
              >
                <i class="bi bi-instagram" style="color: #ff00eeff; font-size: 34px;"></i>
              </button>

              <button
                type="button"
                class="btn p-1"
                aria-label="Google / Blogspot"
                (click)="openInNewTab('https://bellasartes.blogspot.com')"
              >
                <i class="bi bi-google" style="color: #ff4800ff; font-size: 34px;"></i>
              </button>

              <button
                type="button"
                class="btn p-1"
                aria-label="YouTube"
                (click)="openInNewTab('https://www.youtube.com/channel/UCkYf1NyZ1kUl3965WgeL6rw')"
              >
                <i class="bi bi-youtube" style="color: #ff0011ff; font-size: 34px;"></i>
              </button>
              
              <button
                type="button"
                class="btn p-1"
                aria-label="TikTok"
                (click)="openInNewTab('https://www.tiktok.com/@bellasartes.ayacucho')"
              >
                <i class="bi bi-tiktok" style="color: #9500ffff; font-size: 34px;"></i>
              </button>

            </div>
          </div>
        </div>
      </div>
    </div>
  `
})
export class WwwwwwComponent implements OnInit {
  readonly imageSrc = signal<string>('');
  readonly currentYear = new Date().getFullYear();
  readonly pageName = ''; 

  ngOnInit(): void {
    const day = new Date().getDay(); // 0 (Sunday) to 6 (Saturday)
    
    // Assign path directly since they are static assets
    const svgIndex = day === 0 ? 7 : day; // Adjust if your files are 1 to 7
    this.imageSrc.set(`/www${svgIndex}.svg`);
  }

  openInNewTab = (url: string) => {
    window.open(url, '_blank', 'noreferrer');
  };
}